<template>
  <v-container style="width: 530px">
    <v-row>
      <v-col cols="6" style="margin-bottom: 0; padding-bottom: 2px">
        <div v-for="mitem in actions" v-bind:key="mitem.id">
          <template v-if="(mitem.enabled === undefined || mitem.enabled) && checkAccess(mitem.module)">
            <v-hover v-slot="{ hover }">
              <div>
                <v-btn class="mitem justify-start pl-1" style="width: 200px" plain @click="clickRoute(mitem)">
                  <v-icon>{{ mitem.icon }}</v-icon>
                  &nbsp;<span v-if="mitem.subtext !== undefined && mitem.subtext !== null"
                              style="text-align: left; line-height: 85%; overflow: hidden; text-overflow: ellipsis; max-width: 160px">
                <span style="font-size: 75%">{{ mitem.text }}</span><br />
                <span class="blue--text" style="font-size: 90%; padding-left: 2px">{{ mitem.subtext }}</span>
               </span>
                  <span v-else>{{ mitem.text }}</span>
                </v-btn>
                <span v-if="mitem.shortcut !== undefined && mitem.shortcut !== null && hover"
                      class="grey--text font-italic"
                      style="font-size: 80%">{{ mitem.shortcut }}</span>
              </div>
            </v-hover>
            <v-divider v-if="mitem.divider !== undefined && mitem.divider"
                       style="margin-left: 2px; margin-right: 2px" />
          </template>
        </div>
      </v-col>
      <v-divider vertical style="margin-top: 10px; margin-bottom: 10px" />
      <v-col cols="6" style="margin-bottom: 0; padding-bottom: 2px">
        <div style="font-weight: bold">{{ $t("main_menu.reports.title") }}</div>
        <div v-for="ritem in reports" v-bind:key="ritem.id">
          <v-btn v-if="checkRole(ritem.role)" class="mitem rsmall" plain @click="clickRoute(ritem)">{{ ritem.text }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row style="margin-top: 2px; padding-top: 2px">
      <v-col cols="12" style="margin-top: 0; padding-top: 2px">
        <v-divider style="margin: 6px 5px" />
        <span class="menuinfo">{{ userFullName }}</span>
        <v-btn class="mitem msmall" plain @click="logout">
          <v-icon small>mdi-logout</v-icon>
          &nbsp;{{ $t("main_menu.logout") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";

export default {
  name: "MainMenu",

  data() {
    return {
      actions: [
        {
          id: 1,
          icon: "mdi-domain",
          text: this.$t("main_menu.actions.company_select"),
          subtext: "",
          enabled: true,
          call: this.showCompanySelectionDialog,
          shortcut: "F2"
        },
        {
          id: 2,
          icon: "workspaces",
          text: this.$t("main_menu.actions.groupset_select"),
          subtext: "",
          enabled: true,
          call: this.showGroupsetSelectionDialog,
          shortcut: "F4"
        },
        {
          id: 3,
          icon: "map",
          text: this.$t("main_menu.actions.map"),
          enabled: true,
          route: "map",
          shortcut: "F9"
        },
        {
          id: 4,
          icon: "grid_view",
          text: this.$t("main_menu.actions.map_preview"),
          enabled: true,
          route: "map-preview",
          shortcut: "Alt+G"
        },
        {
          id: 5,
          icon: "calendar_month",
          text: this.$t("main_menu.actions.plan"),
          enabled: true,
          divider: true,
          route: "plan",
          module: "contract"
        },
        {
          id: 6,
          icon: "gps_fixed",
          text: this.$t("main_menu.actions.vehicle_select"),
          enabled: true,
          call: this.showVehicleSelectionDialog,
          shortcut: "F8"
        },
        {
          id: 7,
          icon: "search",
          text: this.$t("main_menu.actions.find"),
          enabled: true,
          call: this.showFindVehiclesDialog,
          divider: true,
          shortcut: "Ctrl+F8"
        },
        {
          id: 8,
          icon: "local_gas_station",
          text: this.$t("main_menu.actions.refueling"),
          enabled: true,
          call: this.showRefuelingDialog,
          divider: true,
          shortcut: "Alt+R"
        },
        {
          id: 9,
          icon: "mdi-car",
          text: this.$t("main_menu.actions.vehicles"),
          enabled: true,
          route: "data/vehicles",
          module: "vehicle"
        },
        {
          id: 10,
          icon: "person",
          text: this.$t("main_menu.actions.persons"),
          enabled: true,
          route: "data/persons",
          module: "person"
        },
        {
          id: 11,
          icon: "workspaces",
          text: this.$t("main_menu.actions.groupsets"),
          enabled: true,
          route: "data/groupsets",
          module: "groupset"
        },
        {
          id: 12,
          icon: "widgets",
          text: this.$t("main_menu.actions.contracts"),
          enabled: true,
          route: "data/contracts",
          module: "contract"
        },
        {
          id: 13,
          icon: "store",
          text: this.$t("main_menu.actions.subjects"),
          enabled: true,
          route: "data/subjects",
          module: "subject"
        },
        {
          id: 14,
          icon: "share_location",
          text: this.$t("main_menu.actions.sharings"),
          enabled: true,
          route: "data/sharings",
          module: "sharing"
        },
        {
          id: 15,
          icon: "mdi-domain",
          text: this.$t("main_menu.actions.companies"),
          enabled: true,
          route: "data/companies",
          module: "company"
        }
      ],
      reports: [
        { id: 1, text: this.$t("report.logbook.title"), enabled: true, route: "report/logbook" },
        { id: 2, text: this.$t("report.performance.title"), enabled: true, route: "report/performance" },
        {
          id: 3,
          text: this.$t("report.machine-performance.title"),
          enabled: true,
          route: "report/machine-performance"
        },
        { id: 4, text: this.$t("report.driver-performance.title"), enabled: true, route: "report/driver-performance" },
        { id: 5, text: this.$t("report.planned-services.title"), enabled: true, route: "report/planned-services" },
        { id: 6, text: this.$t("report.temperature.title"), enabled: true, route: "report/temperature" },
        { id: 7, text: this.$t("report.tanks.title"), enabled: true, route: "report/tanks" },
        { id: 8, text: this.$t("report.tachograph.title"), enabled: true, route: "report/tachograph" },
        { id: 9, text: this.$t("report.travel-expenses.title"), enabled: true, route: "report/travel-expenses" },
        { id: 10, text: this.$t("report.vehicles-summary.title"), enabled: true, route: "report/vehicles-summary" },
        { id: 11, text: this.$t("report.countries-summary.title"), enabled: true, route: "report/countries-summary" },
        { id: 12, text: this.$t("report.abroad-summary.title"), enabled: true, route: "report/abroad-summary" },
        { id: 13, text: this.$t("report.refuelings.title"), enabled: true, route: "report/refuelings" },
        {
          id: 14,
          text: this.$t("report.companies-summary.title"),
          enabled: true,
          route: "report/companies-summary",
          role: "superuser"
        }
      ]
    };
  },

  methods: {
    clickRoute(mitem) {
      if (mitem.route !== undefined && mitem.route !== null)
        this.$router.push({ name: mitem.route });
      else if (mitem.call !== undefined && mitem.call !== null)
        mitem.call();
    },

    showCompanySelectionDialog() {
      this.$store.dispatch("dialogs/showDialog", { dialog: "companySelection", options: true });
    },

    showGroupsetSelectionDialog() {
      this.$store.dispatch("dialogs/showDialog", { dialog: "groupsetSelection", options: true });
    },

    showVehicleSelectionDialog() {
      this.$store.dispatch("dialogs/showDialog", { dialog: "vehicleSelection", options: true });
    },

    showFindVehiclesDialog() {
      this.$store.dispatch("dialogs/showDialog", { dialog: "findVehicle", options: true });
    },

    showRefuelingDialog() {
      this.$store.dispatch("dialogs/showDialog", { dialog: "refueling", options: { refueling: null } });
    },

    checkAccess(module) {
      return module === undefined || module === null || this.canRead(module);
    },

    checkRole(role) {
      return role === undefined || role === null || this.accessRole(role);
    },

    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push({ path: "/" });
    },

    refreshActions() {
      const token = this.$store.state.auth.token;
      let actions = [...this.actions];

      actions[0].enabled = token !== null && token.companies !== null && token.companies.length > 1;
      actions[0].subtext = this.$store.state.auth.company.name;

      actions[1].subtext = (this.$store.state.groupsets.groupset != null)
        ? this.$store.state.groupsets.groupset.name
        : this.$t("dialog.groupset_selection.view_all");

      //actions[3].enabled = token !== null && token.superuser !== null && token.superuser;
      //actions[4].enabled = this.accessRole("admin");

      this.actions = actions;
    },

    changeLanguage() {
      i18n.change("sk");
    }
  },

  watch: {
    "$store.state.auth.token": function() {
      this.refreshActions();
    },

    "$store.state.groupsets.groupset": function() {
      this.refreshActions();
    },

    "$store.state.auth.company": function() {
      this.refreshActions();
    }
  },

  computed: {
    company() {
      return this.$store.state.auth.company;
    },

    userFullName() {
      return (this.$store.state.auth.token.firstName || "") + " " + (this.$store.state.auth.token.lastName || "");
    }
  },

  mounted() {
    this.refreshActions();
  }
};
</script>

<style scoped lang="sass">
.mitem
  text-transform: unset !important
  font-weight: normal !important

.msmall
  padding: 0 5px !important
  margin: 0 5px !important
  float: right
  height: 24px !important

.rsmall
  height: 28px !important

.menuinfo
  font-size: 85%
  color: gray
  padding: 0 5px
  background-color: transparent !important
</style>
